import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentModifiedByDetails } from '../../hooks';

export const ShipmentModifiedBySelect = ({
  placeholder = '',
  label = '',
  rules = [],
  name,
  modifiedType = 1,
  margin,
  disabled,
  editMode,
  mode = 'single',
  tabIndex,
}) => {
  const { selectedCompany } = useSelector((state) => state.auth);

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: options = [], isLoading } = useGetShipmentModifiedByDetails({
    modifiedByType: modifiedType,
    companyId: selectedCompany?.companyId,
  });

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={
        placeholder
          ? placeholder
          : modifiedType === 1
            ? t('translation:default.fields.userName.placeholder')
            : t('translation:default.fields.shipmentCreatedBy.email')
      }
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      disabled={disabled}
      editMode={editMode}
      mode={mode}
      tabIndex={tabIndex}
    />
  );
};
